import React, { useEffect } from 'react';
import { Platform, StyleSheet } from 'react-native';
import { NavigationContainer } from '@react-navigation/native';  // Per React Navigation (mobile)
import { createStackNavigator } from '@react-navigation/stack';
import { HashRouter as Router, Routes, Route } from 'react-router-dom'; // Per il web
import Home from './home';
import Product from './product';
import PageProducts from './pageProducts';
import Cart from './cart';
import FaqPage from './faqPage';
import ContactPage from './contactPage';
import LimitedEditionPage from './limitedEditionPage';
import NavBar from './navBar'; // Assicurati che NavBar sia nel contesto di navigazione

// Crea lo stack navigator per mobile
const Stack = createStackNavigator();

function App() {
  if (Platform.OS === 'web') {
 
    return (
      <NavigationContainer>
      <Router>
        <NavBar /> {/* Ora NavBar è dentro il contesto di navigazione */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/PageProducts" element={<PageProducts />} />
          <Route path="/PageProducts/Product/:id" element={<Product />} />
          <Route path="/FaqPage" element={<FaqPage />} />
          <Route path="/ContactPage" element={<ContactPage />} />
          <Route path="/LimitedEditionPage" element={<LimitedEditionPage />} />
          <Route path="/FaqPage" element={<FaqPage />} />
          <Route path="/Cart" element={<Cart />} />
        </Routes>
      </Router>
    </NavigationContainer>
    );
  
  }

  // // Altrimenti, utilizza React Navigation per mobile
  // return (
  //   <NavigationContainer linking={linking}>
  //     <Stack.Navigator>
  //       <Stack.Screen name="Home" component={Home} options={{ headerShown: false }} />
  //       <Stack.Screen name="PageProducts" component={PageProducts} options={{ headerShown: false }} />
  //       <Stack.Screen name="Product" component={Product} options={{ headerShown: false }} />
  //       <Stack.Screen name="Cart" component={Cart} options={{ headerShown: false }} />
  //       <Stack.Screen name="FaqPage" component={FaqPage} options={{ headerShown: false }} />
  //       <Stack.Screen name="ContactPage" component={ContactPage} options={{ headerShown: false }} />
  //       <Stack.Screen name="LimitedEditionPage" component={LimitedEditionPage} options={{ headerShown: false }} />
  //     </Stack.Navigator>
  //   </NavigationContainer>
  // );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'white',
    alignItems: 'center',
    justifyContent: 'center',
  },
  logo: {
    height: 150,
    width: 300,
    marginBottom: 20,
  },
  subscribeButton: {
    backgroundColor: '#007BFF',
    paddingHorizontal: 15,
    paddingVertical: 10,
    borderRadius: 5,
  },
  subscribeButtonText: {
    color: '#fff',
    fontSize: 16,
  },
});

export default App;
